import { z } from "zod";
import { DepartureKitIssuanceStatusV1Schema } from "../contracts/departure-kit-v1.js";
/** Constitution §4.8 release labels — frozen for Step 9. */
export const ReleaseLabelV1Schema = z.enum([
    "Fully Enrein QA-Gated",
    "Agency-Controlled Release",
    "Partial Readiness",
    "Not Recommended for Release",
    "Release Blocked",
]);
export const ReleaseLabelReasonV1Schema = z
    .object({
    schemaVersion: z.literal("release-label-reason.v1.0"),
    code: z.string().min(1),
    message: z.string().min(1),
})
    .strict();
export const ReleaseLabelInputV1Schema = z
    .object({
    schemaVersion: z.literal("release-label-input.v1.0"),
    qaStatus: z.enum(["QA_PASS", "QA_WARN", "QA_FAIL", "QA_NOT_RUN", "UNAVAILABLE"]),
    qaCompleted: z.boolean(),
    reportAvailable: z.boolean(),
    reportStale: z.boolean(),
    reportAllowsFullPassLanguage: z.boolean(),
    dkIssuanceStatus: z.union([DepartureKitIssuanceStatusV1Schema, z.literal("UNAVAILABLE")]),
    passingVsApprovedMismatch: z.boolean(),
    dispositionCounts: z
        .object({
        passed: z.number().int().nonnegative(),
        failed: z.number().int().nonnegative(),
        warning: z.number().int().nonnegative(),
        skipped: z.number().int().nonnegative(),
        disabled: z.number().int().nonnegative(),
        managerException: z.number().int().nonnegative(),
        notRun: z.number().int().nonnegative(),
        unresolved: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    })
        .strict(),
    governanceCoveragePercent: z.number().min(0).max(100),
    governanceAllowsFullPassLanguage: z.boolean(),
    clientResponsibilityItemCount: z.number().int().nonnegative(),
})
    .strict();
export function dispositionCountsFromChecks(dispositions) {
    const counts = {
        passed: 0,
        failed: 0,
        warning: 0,
        skipped: 0,
        disabled: 0,
        managerException: 0,
        notRun: 0,
        unresolved: 0,
        total: dispositions.length,
    };
    for (const d of dispositions) {
        switch (d) {
            case "PASSED":
                counts.passed += 1;
                break;
            case "FAILED":
                counts.failed += 1;
                break;
            case "WARNING":
                counts.warning += 1;
                break;
            case "SKIPPED":
                counts.skipped += 1;
                break;
            case "DISABLED":
                counts.disabled += 1;
                break;
            case "MANAGER_EXCEPTION":
                counts.managerException += 1;
                break;
            case "NOT_RUN":
                counts.notRun += 1;
                break;
            case "UNRESOLVED":
                counts.unresolved += 1;
                break;
            default:
                break;
        }
    }
    return counts;
}
export function qaStatusForReleaseLabel(status, completed) {
    if (!status)
        return "UNAVAILABLE";
    if (!completed && status === "QA_PASS")
        return "QA_NOT_RUN";
    return status;
}
//# sourceMappingURL=release-label.js.map